import { ReactNode } from "react";
import { TooltipWrapper } from "~/components/TooltipWrapper";
import { Box, Button, SxProps, Theme } from "@mui/material";

interface Props {
  label?: string;
  tooltip?: string;
  onClick?: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  key: string;
  "data-testid"?: string;
  icon?: ReactNode;
}

export const TriageToolbarButton = ({
  disabled,
  tooltip,
  onClick,
  key,
  label,
  icon,
  ...otherProps
}: Props) => {
  return (
    <TooltipWrapper hideTooltip={!disabled} key={key} title={tooltip}>
      <Box>
        <Button
          data-testid={otherProps["data-testid"]}
          variant="outlined"
          onClick={onClick}
          disabled={disabled}
          sx={{
            color: "common.white",
            borderWidth: "2px",
            borderColor: "primary.main",
            "&.Mui-disabled": {
              borderWidth: "2px",
              borderColor: "text.disabled",
              color: "text.disabled",
            },
          }}
          startIcon={icon}
        >
          {label}
        </Button>
      </Box>
    </TooltipWrapper>
  );
};
